import React, { useEffect, useRef } from 'react';
import { useIntl } from '@atlassian/jira-intl';
import useDebouncedCallback from '@atlassian/jira-platform-use-debounce/src/utils/use-debounce-callback/index.tsx';
import { SearchField } from '@atlassian/jira-searchfield';
import { useArchiveIssueActions } from '../../controllers/main.tsx';
import { useArchiveIssueStates } from '../../controllers/selectors.tsx';
import messages from './messages';

const Search = () => {
	const { formatMessage } = useIntl();
	const inputRef = useRef<HTMLInputElement>(null);

	const { setSearchBy } = useArchiveIssueActions();
	const { searchBy } = useArchiveIssueStates();

	const [debouncedQuery] = useDebouncedCallback((query) => {
		setSearchBy(query);
	}, 500);

	useEffect(() => {
		if (searchBy === '' && inputRef.current && inputRef.current.nextSibling) {
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(inputRef.current.nextSibling.childNodes[0] as HTMLButtonElement)?.click();
		}
	}, [searchBy]);

	return (
		<SearchField
			inputRef={inputRef}
			isAlwaysExpanded
			placeholderAlwaysVisible
			placeholder={formatMessage(messages.searchIssuesMessage)}
			value={searchBy}
			onChange={(query) => debouncedQuery(query)}
			testId="issue-archival-archives.ui.search.search-input"
		/>
	);
};

export default Search;
